import React, { useState, useEffect } from 'react'
import { useOutletContext } from 'react-router-dom'
import { Stack, Menu, Grid2 as Grid } from '@mui/material'
import { Container, Col, Row, ListGroup } from 'react-bootstrap'
import _ from 'lodash'

import useFetchData from 'Shared/Hooks/useFetchData'
import { FloatingDropdown } from 'Shared/Components/FloatingLabel/FloatingLabel'
import useLoop from 'Shared/Hooks/useLoop'
import { apiUrl } from 'Shared/utils'

import { PiDeviceMobileCameraBold } from "react-icons/pi";
import { RiCameraFill, RiCameraAiFill } from "react-icons/ri"

import Player from './components/Player'
import "./components/style.css"

const Tab = ({ i, openStream }) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const open = (data) => {
    setAnchorEl()
    openStream(data)
  }
  
  if (i["type"] == "ip_camera") {
    return (<>
      <ListGroup.Item className="border-0" action onClick={(event) => {i["ai_detection"] ? setAnchorEl(event.currentTarget) : open({ "camera_id": `live/${i["camera_id"]}`, "name": `${i["name"]} (Live)` })}}>
        <Stack justifyContent="space-between" direction="row" spacing={2} style={{ height: "100%", width: "100%", alignItems: "center" }}>
          <Stack justifyContent="start" direction="row" spacing={2} style={{ height: "100%", width: "100%", alignItems: "center" }}>
            <div style={{ position: "relative", display: "inline-block" }}>
              {i["ai_detection"] ? <RiCameraAiFill size={20} /> : <RiCameraFill size={20} />}
              <div style={{ position: "absolute", right: 0, bottom: 0, width: 8, height: 8, borderRadius: "50%", backgroundColor: i["online"] ? "green" : "red" }}/>
            </div>

            <div>{i["name"]}</div>
          </Stack>

          {/* {i["ai_detection"] ? <MdArrowForwardIos size={15} /> : <div />} */}
        </Stack>
      </ListGroup.Item>

      <Menu
        anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)} MenuListProps={{ sx: { py: 0 } }}
        anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
        transformOrigin={{ vertical: 'center', horizontal: 'left' }}
        PaperProps={{ elevation: 4 }}
      >
        <ListGroup variant="flush" style={{ width: "130px" }}>
          <ListGroup.Item className="border-0" action onClick={() => open({ "camera_id": `live/${i["camera_id"]}`, "name": `${i["name"]} (Live)` })}>
            <div>{"Live"}</div>
          </ListGroup.Item>

          {i["ai_detection"] && <>
            <ListGroup.Item className="border-0" action onClick={() => open({ "camera_id": `ai_detection/${i["camera_id"]}`, "name": `${i["name"]} (AI Detection)` })}>
              <div>{"AI Detection"}</div>
            </ListGroup.Item>
          </>}
        </ListGroup>
      </Menu>
    </>)
  }
  else if  (i["type"] === "body_camera") {
    return (
      <ListGroup.Item className="border-0" action onClick={() => openStream({ "camera_id": `live/${i["camera_id"]}`, "name": `${i["name"]}` })}> 
        <Stack justifyContent="start" direction="row" spacing={2} style={{ height: "100%", width: "100%", alignItems: "center" }}>
          <div style={{ position: "relative", display: "inline-block" }}>
            <PiDeviceMobileCameraBold size={15} />
            <div style={{ position: "absolute", right: 0, bottom: 0, width: 8, height: 8, borderRadius: "50%", backgroundColor: i["online"] ? "green" : "red" }}/>
          </div>

          <div>{i["name"]}</div>
        </Stack>
      </ListGroup.Item>
    )
  } 
 
  // else if  (i["type"] === "proximity") {
  //   return (
  //     <ListGroup.Item className="border-0" action onClick={() => openStream({ "camera_id": `proximity/${i["camera_id"]}`, "name": `${i["name"]}` })}> 
  //       <Stack justifyContent="start" direction="row" spacing={2} style={{ height: "100%", width: "100%", alignItems: "center" }}>
  //         <div style={{ position: "relative", display: "inline-block" }}>
  //           <TbCarCrane size={15} />
  //         </div>

  //         <div>{i["name"]}</div>
  //       </Stack>
  //     </ListGroup.Item>
  //   )
  // }
  else {
    return <></>
  }
}

const Live = () => {
  const { setPageLoading } = useOutletContext()
  
  const { send } = useFetchData()

  const [cameras, setCameras] = useState([])

  const [streamList, setStreamList] = useState([])
  const [grid, setGrid] = useState("2")
  const [mode, setMode] = useState("streaming")

  const [isVisible, setIsVisible] = useState(document.visibilityState === 'visible');
  const [token, setToken] = useState(localStorage.getItem("access_token"))

  useEffect(() => {
    const handleStorageChange1 = (e) => {
      setToken(localStorage.getItem("access_token"))
    };
  
    const handleStorageChange2 = (e) => {
      if (e.key === "access_token") {
        setToken(localStorage.getItem("access_token"))
      }
    };

    const handleVisibilityChange = () => {
      setIsVisible(document.visibilityState === 'visible');
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener("access_token_change", handleStorageChange1);
    window.addEventListener("storage", handleStorageChange2);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);

      window.removeEventListener("access_token_change", handleStorageChange1);
      window.removeEventListener("storage", handleStorageChange2);
    };
  }, []);

  const fetchCameras = async () => {
    const cameras = []

    const body1 = await send({
      method: "GET",
      url: `${apiUrl}/camera/list`,
      returnType: "json"
    })

    body1.forEach((i) => {
      cameras.push({
        "camera_id": i["camera_id"],
        "name": `${i["name"]}`,
        "type": i["body_camera"] ? "body_camera" : "ip_camera",
        "live": true,
        "ai_detection": i["ai_enabled"],
        "online": i["online"]
      })
    })

    // const body2 = await send({
    //   method: "GET",
    //   url: `${apiUrl}/proximity/list`,
    //   returnType: "json"
    // })

    // body2.forEach((i) => {
    //   if (i["live"]) {
    //     cameras.push({
    //       "camera_id": i["device_id"],
    //       "name": `${i["name"]}`,
    //       "type": "proximity",
    //       "live": true,
    //       "ai_detection": false
    //     })
    //   }
    // })

    setCameras(cameras)
  }

  useEffect(() => {
    const init = async () => {
      setPageLoading(true)

      await Promise.all([
        fetchCameras()
      ])

      initArray(2)

      setPageLoading(false)
    }

    init()
  }, [])

  useLoop(fetchCameras, 10000)
  
  const initArray = (grid) => {
    const array = Array.apply(null, {length: grid}).map(i => Array.apply(null, {length: grid}).map(i => null))
    
    setStreamList(array)
    setGrid(grid.toString())
  }

  const clearStream = (row, col) => {
    const temp = _.cloneDeep(streamList)
    temp[row][col] = null

    setStreamList(temp)
  }

  const changeGrid = (grid) => {
    initArray(grid)
  }

  const openStream = (stream) => {
    for (let row of streamList) {
      for (let col of row) {
        if (col != null) {
          if (col[0] === stream["camera_id"]) {
            return
          }
        }
      }
    }

    for (let [i, row] of streamList.entries()) {
      for (let [j, col] of row.entries()) {
        if (col == null) {
          const temp = _.cloneDeep(streamList)
          temp[i][j] = [stream["camera_id"], stream["name"]]

          setStreamList(temp)

          return
        }
      }
    }
  }

  return (
    <div className="mainContainer" style={{ width: "100%", height: "100%", borderRadius: "15px", backgroundColor: "white", padding: "10px" }}>
      <Container className="mainContainer" fluid>
        <Row style={{ flexGrow: 1, overflow: "hidden", minHeight: "540px" }}>
          <Col xs={3} style={{ height: "100%", overflow: "auto", paddingLeft: 0, paddingRight: 0 }}>
            <div style={{ minWidth: "160px" }}>
              <div style={{ width: "100%", paddingRight: "8px" }}>
                <Grid container spacing={1}>
                  <Grid item size={{ xs: 7 }}>
                    <FloatingDropdown label="Channel" name="channel" value={mode} onChange={(v) => setMode(v)} options={[
                      {value: "streaming", label: "1"},
                      {value: "streaming2", label: "2"},
                    ]}/>
                  </Grid>
                  <Grid item size={{ xs: 5 }}>
                    <FloatingDropdown label="Grid" name="grid" value={grid} onChange={(v) => changeGrid(v)} options={[
                      {value: "1", label: "1"},
                      {value: "2", label: "4"},
                      {value: "3", label: "9"},
                      {value: "4", label: "16"},
                    ]}/>
                  </Grid>
                </Grid>
              </div>

              <div style={{ width: "100%" }}>
                <ListGroup variant="flush">
                  {(cameras ?? []).map((i) => 
                    <Tab i={i} openStream={openStream}/>
                  )}
                </ListGroup>
              </div>
            </div>
          </Col>

          <Col xs={9} style={{ height: "100%", paddingLeft: 0, paddingRight: 0 }}>
            {streamList.map((i, row) => <>
              <Grid
                container
                sx={{
                  '--Grid-borderWidth': '1px',
                  borderTop: 'var(--Grid-borderWidth) solid',
                  borderLeft: 'var(--Grid-borderWidth) solid',
                  borderColor: 'white',
                  '& > div': {
                    borderRight: 'var(--Grid-borderWidth) solid',
                    borderBottom: 'var(--Grid-borderWidth) solid',
                    borderColor: 'white'
                  },
                  height: `${100/grid}%`
                }}
              >
                {i.map((j, col) => <>
                  <Grid item size={{ xs: 12/grid }}>
                    <Player clearStream={() => clearStream(row, col)} item={j} mode={mode} isVisible={isVisible} token={token}/>
                  </Grid>
                </>)}
              </Grid>
            </>)}
          </Col>
        </Row>
      </Container> 
    </div>
  )
}

export default Live
